import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NoiseAbatement } from '../models/noise-abatement.model';
import { NoiseAbatementService } from '../service/noise-abatement.service';
var EditNoiseAbatementComponent = /** @class */ (function () {
    function EditNoiseAbatementComponent(_matDialogRef, _snackBar, data, _noiseAbatementService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._noiseAbatementService = _noiseAbatementService;
        this.isNew = false;
        this.isLoading = false;
        this.noise = data.noise || new NoiseAbatement();
        this.isNew = data.isNew || false;
        this.airportID = data.airID;
        this.originalNoise = Object.assign(new NoiseAbatement(), data.noise);
        this.itemsToChange = new Set();
        this.selectedRunway = this.noise.runway ? this.noise.runway : 'All';
        this.selectedAppliesTo = NoiseAbatement.formatAppliesTo(this.noise.appliesTo);
        this.selectedApproachDeparture = NoiseAbatement.formatAppDep(this.noise.appDep);
        this.selectedText = this.noise.text ? this.noise.text : '';
        this.landingSurfaces = data.landingSurfaces || [];
    }
    EditNoiseAbatementComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            runway: new FormControl(this.selectedRunway, [Validators.required]),
            appliesTo: new FormControl(this.selectedAppliesTo, [Validators.required]),
            appDep: new FormControl(this.selectedApproachDeparture, [Validators.required]),
            text: new FormControl(this.selectedText, [Validators.required, Validators.maxLength(1000)])
        });
    };
    Object.defineProperty(EditNoiseAbatementComponent.prototype, "runways", {
        get: function () {
            var tempRunways = [];
            for (var _i = 0, _a = this.landingSurfaces; _i < _a.length; _i++) {
                var surface = _a[_i];
                for (var _b = 0, _c = surface.takeOffLandAreas; _b < _c.length; _b++) {
                    var takeOffLandArea = _c[_b];
                    tempRunways.push(takeOffLandArea.name);
                }
            }
            return tempRunways;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditNoiseAbatementComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.noise.runway = this.formGroup.get('runway').value;
                        this.noise.appliesTo = NoiseAbatement.parseAppliesTo(this.formGroup.get('appliesTo').value);
                        this.noise.appDep = NoiseAbatement.parseAppDep(this.formGroup.get('appDep').value);
                        this.noise.text = this.formGroup.get('text').value;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._noiseAbatementService.postNoiseAbatement(this.airportID, this.noise)];
                    case 1:
                        res = _a.sent();
                        this.noise = NoiseAbatement.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._noiseAbatementService.putNoiseAbatement(this.airportID, this.noise)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.noise, NoiseAbatement.parse(res));
                        this.noise = NoiseAbatement.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, noise: this.noise });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditNoiseAbatementComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditNoiseAbatementComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.noise, this.originalNoise);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditNoiseAbatementComponent;
}());
export { EditNoiseAbatementComponent };
